import { render, staticRenderFns } from "./OrderOnBehalf.vue?vue&type=template&id=52be27c8&scoped=true"
import script from "./OrderOnBehalf.vue?vue&type=script&lang=js"
export * from "./OrderOnBehalf.vue?vue&type=script&lang=js"
import style0 from "./OrderOnBehalf.vue?vue&type=style&index=0&id=52be27c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52be27c8",
  null
  
)

export default component.exports